<template>
  <!--콘텐츠 영역-->

  <div id="sub_contents" class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>

    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">재무정보</h3>
      </div>
      <div class="txt">
        <h4 class="fs-30">재무 하이라이트</h4>
        <h6 class="fs-14 pdt30 tr">단위 : 백만</h6>
        <div class="graph_box">
          <div class="graph_cont">
            <h6>매출액</h6>
            <ul class="graph_y">
              <li>
                30000
                <span></span>
              </li>
              <li>
                20000
                <span></span>
              </li>
              <li>
                10000
                <span></span>
              </li>
              <li>
                0
                <span></span>
              </li>
            </ul>
            <ul class="graph_x">
              <li>
                2023
                <p class="graph_1">
                  <span>20,381</span>
                </p>
              </li>
              <li>
                2024
                <p class="graph_2">
                  <span>20,444</span>
                </p>
              </li>
              <li>
                2025
                <p class="graph_3">
                  <span>20,252</span>
                </p>
              </li>
            </ul>
          </div>

          <div class="graph_cont">
            <h6>영업이익</h6>
            <ul class="graph_y">
              <li>
                9000
                <span></span>
              </li>
              <li>
                6000
                <span></span>
              </li>
              <li>
                3000
                <span></span>
              </li>
              <li>
                0
                <span></span>
              </li>
            </ul>
            <ul class="graph_x">              
              <li>
                2023
                <p class="graph_4">
                  <span>7,487</span>
                </p>
              </li>
              <li>
                2024
                <p class="graph_5">
                  <span>6,442</span>
                </p>
              </li>
              <li>
                2025
                <p class="graph_6">
                  <span>5,515</span>
                </p>
              </li>
            </ul>
          </div>
          <div class="graph_cont">
            <h6>당기순이익</h6>
            <ul class="graph_y">
              <li>
                9000
                <span></span>
              </li>
              <li>
                6000
                <span></span>
              </li>
              <li>
                3000
                <span></span>
              </li>
              <li>
                0
                <span></span>
              </li>
            </ul>
            <ul class="graph_x">              
              <li>
                2023
                <p class="graph_7">
                  <span>6,116</span>
                </p>
              </li>
              <li>
                2024
                <p class="graph_8">
                  <span>5,723</span>
                </p>
              </li>
              <li>
                2025
                <p class="graph_9">
                  <span>4,494</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="pdb30"></div>
        <h4 class="fs-30 pdt50">재무상태표</h4>
        <h6 class="fs-14 pdt30 pdb10 tr">단위 : 백만</h6>
        <div class="table-wrap">
          <table>
            <colgroup>
              <col width="200px" />
              <col width />
              <col width />
              <col width />
              <!-- <col width />
              <col width />-->
            </colgroup>
            <tr>
              <th>구분</th>
              <th>2025</th>
              <th>2024</th>
              <th>2023</th>
            </tr>
            <tr>
              <td>자산총계</td>
              <td>210,218</td>
              <td>218,987</td>
              <td>222,162</td>
            </tr>
            <tr>
              <td>유동자산</td>
              <td>16,913</td>
              <td>23,773</td>
              <td>26,943</td>
            </tr>
            <tr>
              <td>비유동자산</td>
              <td>193,305</td>
              <td>195,214</td>
              <td>195,218</td>
            </tr>
            <tr>
              <td>부채총계</td>
              <td>49,943</td>
              <td>57,349</td>
              <td>65,728</td>
            </tr>
            <tr>
              <td>유동부채</td>
              <td>36,426</td>
              <td>44,359</td>
              <td>52,799</td>
            </tr>
            <tr>
              <td>비유동부채</td>
              <td>13,517</td>
              <td>12,990</td>
              <td>12,929</td>
            </tr>
            <tr>
              <td>자본총계</td>
              <td>160,276</td>
              <td>161,638</td>
              <td>156,434</td>
            </tr>
          </table>
        </div>
        <h4 class="fs-30">손익계산서</h4>
        <h6 class="fs-14 pdt30 pdb10 tr">단위 : 백만</h6>
        <div class="table-wrap">
          <table>
            <colgroup>
              <col width="200px" />
              <col width />
              <col width />
              <col width />
              <!-- <col width />
              <col width />-->
            </colgroup>
            <tr>
              <th>구분</th>
              <th>2025</th>
              <th>2024</th>
              <th>2023</th>
            </tr>
            <tr>
              <td>매출액</td>
              <td>20,252</td>
              <td>20,444</td>
              <td>20,381</td>
            </tr>
            <tr>
              <td>매출총이익</td>
              <td>10,186</td>
              <td>11,432</td>
              <td>11,715</td>
            </tr>
            <tr> 
              <td>영업이익</td>
              <td>5,515</td>
              <td>6,442</td>
              <td>7,487</td>
            </tr>
            <tr>
              <td>법인세비용차감전순이익</td>
              <td>5,676</td>
              <td>6,708</td>
              <td>7,854</td>
            </tr>
            <tr>
              <td>당기순이익</td>
              <td>4,494</td>
              <td>5,723</td>
              <td>6,116</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "finance.vue",
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/sub05/finance.vue